import React from 'react'

// Removed Input, Modal imports
// Added CBInput, CBModal imports
import { CBInput, CBModal } from '../../../core/components/cbd';


const EditOrgModal = ({
	currentOrg,
	visible,
	handleOk,
	confirmLoading,
	handleCancel,
	newOrgId,
	setNewOrgId
}) => {

	const handleInputChange = (e) => {
		setNewOrgId(e.target.value) // Keep this handler for CBInput
	}
	return (
		// Replaced Modal with CBModal
		<CBModal
			title="Edit Org"
			visible={visible}
			onPositiveClick={handleOk} // Map onOk to onPositiveClick
			confirmLoading={confirmLoading} // Assuming CBModal supports this
			onCancelClick={handleCancel} // Map onCancel to onCancelClick
			// positiveLabel="OK" // Default
			// negativeLabel="Cancel" // Default
		>
			<p className="mb-4">Change the Organization for a User</p> {/* Added margin */}
			{/* Replaced Input.Group with div and spacing */}
			<div className="space-y-4">
				{/* Replaced Input with CBInput */}
				<CBInput
					// style={{ paddingBottom: '1em' }} // Use className for styling
					label={'Current Org'} // Use label prop
					value={currentOrg}
					readOnly={true}
					className="pb-4" // Example padding using Tailwind
				/>
				<CBInput
					// style={{ paddingBottom: '1em' }} // Use className for styling
					value={newOrgId}
					label={'New Org'} // Use label prop
					placeholder={'New Org'}
					onChange={(val) => setNewOrgId(val)} // Adapt onChange
					className="pb-4" // Example padding using Tailwind
				/>
			</div>
		</CBModal>
	)
}

export default EditOrgModal
